import React, { useState, useEffect } from "react"
// import FixProfileNavbar from "../../Components/Navbar/FixProfileNavbar";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
// import { notify } from "react-notify-toast";
import { Link } from "react-router-dom"
import {
  // Search,
  // Pagination,
  Responsive,
  // Menu,
  // Dropdown
} from "semantic-ui-react"
import "./Bookings.css"
import "./Admin.css"
import PopUp from "../../Components/PopUpForm/ShareProfile-PopUp"
// import $ from 'jquery';
import AdminWrapper from "./AdminWrapper"
import { connect } from "react-redux"
import { setTeacher, setAllTeachers, updateSearchStatus, updateTeacherLevel } from "../../redux/admin/admin.actions"
import { API } from "../../API"
import CheckableButton from "../../Components/CheckableButton/CheckableButton"
import SearchBar from "../../Components/SearchBar/SearchBar"
import Pagination from '../../Components/Pagination/Pagination'
import {
  getCurrentPage, getTeacherProfileName,
} from '../../Helper'
import { notify } from "react-notify-toast";
import Modal from "../../Components/Modal/Modal";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import FormField from "../../Components/FormField/FormField";
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);
require("../ValidateDocuments/ValidateDocuments.css")
require("./AllBookings.css")


let pageNumber = 0
const AllTeachers = (props) => {
  pageNumber = pageNumber == 0 ? 1 : pageNumber
  const [user, setUser] = useState() //Shared user
  let [pageNum, setPageNum] = useState(pageNumber)
  let [searchResults, setSearchResults] = useState([])
  let [showCurrentUsers, setShowCurrentUsers] = useState([])
  // let [allUsers, setAllUsers] = useState([])
  const [isPopup, togglePopup] = useState(false)
  const [formType, setFormType] = useState("")
  const [showExportBookingPopup, setShowExportBookingPopup] = useState(false)
  const [exportBookingStartDate, setExportBookingStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportBookingEndDate, setExportBookingEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportBookingTeachers, setExportBookingTeachers] = useState([])
  const [showExportToXeroPopup, setShowExportToXeroPopup] = useState(false)
  const [exportToXeroStartDate, setExportToXeroStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [exportToXeroEndDate, setExportToXeroEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"))
  const [showConfirmChangeStatusPopup, setShowConfirmChangeStatusPopup] = useState(false)
  const [statusChangedTeacher, setStatusChangedTeacher] = useState(undefined)
  const [showConfirmChangeLevelPopup, setShowConfirmChangeLevelPopup] = useState(false)
  const [levelChangedTeacher, setLevelChangedTeacher] = useState(undefined)
  const POFILE_URL = `https://www.readyteacherapp.com/NavigateToShareProfile?id=`
  const allUsers = props.all_users || [];

  useEffect(() => {
    // const getTeachers = async () => {
    API.allTeachers()
      .then((res) => {
        const allTeachers = res.data.filter((t) => !t.deleted_at)
        props.setAllTeachers(allTeachers)
        // setAllUsers(res.data)
        // searchByInstitution()
        setSearchResults(allTeachers)
        setShowCurrentUsers(getCurrentPage(pageNum, allTeachers))
      })
      .catch((err) => {
        console.log(err)
      })
    // }
    // getTeachers()
  }, [])

  useEffect(() => {
    setSearchResults(allUsers)
    setShowCurrentUsers(getCurrentPage(pageNum, allUsers))
  }, [allUsers])

  // Calculate pages -----
  const pages = () => {
    let arr = []
    if (allUsers.length !== 0 && allUsers.length % 10 === 0) {
      for (let i = 1; i <= allUsers.length / 10; i++) {
        arr.push(i)
      }
    } else if (allUsers.length === 0) {
    } else if (allUsers.length !== 0 && allUsers.length % 10 !== 0) {
      for (let i = 1; i <= allUsers.length / 10 + 1; i++) {
        arr.push(i)
      }
    }
    return arr
  }

  const showShareProfile = (user) => {
    setUser(user)
    setFormType("shareProfile")
    togglePopup(true)
  }

  const copyToClipboard = (elementId) => {
    var aux = document.createElement("input")

    // Assign it the value of the specified element
    aux.setAttribute("value", document.getElementById(elementId).innerHTML)

    // Append it to the body
    document.body.appendChild(aux)

    // Highlight its content
    aux.select()

    // Copy the highlighted text
    document.execCommand("copy")

    // Remove it from the body
    document.body.removeChild(aux)
  }

  // const goToDetail = (user) => {
  //   const path = {
  //     user: 'user',
  //     pathname: '/TeacherpersonalDetails',
  //   };
  //   console.log('user: ' + user);
  //   props.history.push(path);
  // };

  const searchByInstitution = (e) => {
    let searchItem = e.target.value.trim().toLowerCase();

    if (searchItem.length > 0) {
      if (allUsers.length > 0) {

        //let search =searchItem
        let filter_users = allUsers.filter((b) =>
          b.first_name === undefined ||
            b.last_name === undefined ||
            b.email === undefined ||
            b.contact_number === undefined ||
            (b.can_deliver === undefined && b.can_delivers === undefined) ||
            b.can_deliver === []
            ? null
            : // ,console.log("No teacher")
            // b.first_name.toLowerCase() +
            // b.last_name.toLowerCase() +
            // b.email.toLowerCase() +
            // b.contact_number.toLowerCase() +
            // getCanDelivers(b.can_deliver)
            filterCriterias(b).includes(searchItem)
        )

        pageNum = 1
        setPageNum(pageNum)
        setSearchResults(filter_users)
        setShowCurrentUsers(getCurrentPage(pageNum, filter_users))
        // setAllUsers(filter_users)
        // pages()
      }
    } else {
      // setAllUsers(props.all_users)
      setSearchResults(allUsers)
      setShowCurrentUsers(getCurrentPage(pageNum, allUsers))
      // pages()
    }

    if (searchItem === "") {
      pageNum = pageNumber
      setPageNum(pageNum)
      setShowCurrentUsers(getCurrentPage(pageNum, allUsers))
    }
  }

  const onPageNumChange = (e) => {
    // console.log(e.target.getAttribute('value'))
    const num = e.target.getAttribute('value')
    setPageNum(num)
    pageNumber = num
    setShowCurrentUsers(getCurrentPage(num, searchResults))
  }

  // const getCanDelivers = (can_deliver) => {
  //   let result = "";
  //   for (let i=0; i<can_deliver.length; i++){
  //     result += can_deliver[i].can_deliver + " ";
  //   }
  //   return result.toLowerCase();
  // }

  const filterCriterias = (b) => {

    let result = (
      b.first_name + " " +
      b.preferred_name + " " +
      b.last_name + " " +
      b.email +
      b.contact_number
    ).toLowerCase()

    if (b.can_delivers) {
      let can_delivers = b.can_delivers;
      for (let category in can_delivers) {
        if (category !== "_id") {
          for (let cl in can_delivers[category]) {
            result += cl.whole_name + " "
          }
        }
      }
    }
    else if (b.can_deliver) {
      let can_deliver = b.can_deliver
      for (let i = 0; i < can_deliver.length; i++) {
        result += can_deliver[i].can_deliver + " "
      }
    }


    // if (b.wwcc_number) result += b.wwcc_number;
    if (b.street_name) result += b.street_name
    if (b.street_type) result += b.street_type
    if (b.street_number) result += b.street_number
    if (b.unit_number) result += b.unit_number
    if (b.address) result += b.address
    if (b.address_line1) result += b.address_line1
    if (b.address_line2) result += b.address_line2
    if (b.street) result += b.street
    if (b.state) result += b.state
    if (b.suburb) result += b.suburb
    if (b.postcode) result += b.postcode
    if (b.visa_grant_number) result += b.visa_grant_number

    return result.toLowerCase()
  }

  const updateExportBookingTeachers = (e) => {
    if (e.target.checked) {
      exportBookingTeachers.push(e.target.id);
    } else {
      const index = exportBookingTeachers.indexOf(e.target.id);
      if (index > -1) {
        exportBookingTeachers.splice(index, 1);
      }
    }
    setExportBookingTeachers(exportBookingTeachers)
    setShowCurrentUsers(getCurrentPage(1, searchResults))
    setShowCurrentUsers(getCurrentPage(pageNum, searchResults))
    // setPageNum(page)
  }

  const handleExportBooking = () => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = `Bookings from ${
      moment(exportBookingStartDate).format("DD-MM-YYYY")} to ${
      moment(exportBookingEndDate).format("DD-MM-YYYY")}`
    if (exportBookingTeachers.length < 1) {
      notify.show("Please select at least one teacher")
    } else {
      API.exportTeacherBookingsByAdmin(
        exportBookingTeachers,
        exportBookingStartDate,
        exportBookingEndDate,
      ).then((res) => {
        link.href = URL.createObjectURL(
          new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"})
        );
        link.click();
        setShowExportBookingPopup(false)
      }).catch((err) => {
        console.log(err);
      })
    }
  }

  const openExportToXeroModal = () => {
    setShowExportToXeroPopup(true)
    API.connectXeroPayroll().then(res => {
      console.log(res)
    })
      .catch(err => {
        notify.show("Cannot connect to Xero")
        console.log(err)
    })
  }

  const handleExportToXero = () => {
    if (exportBookingTeachers.length < 1) {
      notify.show("Please select at least one teacher")
    } else {
      API.importXeroPayRoll(exportBookingTeachers, exportToXeroStartDate, exportToXeroEndDate)
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          notify.show(err.response.data.error)
          console.log(err.response)
        })
    }
  }

  return (
    <AdminWrapper>
      <div>
        <SwitchMenuBar isViewAsTeacher />
        {isPopup && (
          <PopUp user={user} showPopup={togglePopup} formType={formType} />
        )}
        <div className="auth-right d-lg-flex bg-photoregister ">
          <div className="bg-gradient"></div>
          <div className="profile-container mt-4">
            <div className="profile-content-card-area">
              <div className="tab-content clearfix">
                <div className="mt-5">
                  <h1 className="col-12 ">Manage Teachers</h1>
                  <div className="d-flex mt-4 mb-0">
                    {/* <div className="search-label">Search</div> */}
                    {/* <div className="searchbar" id="all-teachers-search"> */}
                    {/* <input
                        id="institution-name-to-search"
                        className="search_input"
                        type="text"
                        name=""
                        placeholder="Search..."
                        onChange={(e) => {
                          searchByInstitution()
                          setPageNum(1)
                        }}
                      />
                      <Link
                        onClick={() => {
                          searchByInstitution()
                        }}
                        pointer={true}
                        className="search_icon font-25"
                      >
                        <i className="mdi mdi-account-search"></i>
                      </Link> */}
                    <SearchBar
                      onChange={searchByInstitution}
                    />
                    {/* </div> */}
                  </div>

                  <div className="availability-table-container mt-0">
                    <button
                      className="btn secondary-button-no-margin-hover btn-c export-bookings-button"
                      onClick={() => setShowExportBookingPopup(true)}
                    >
                      Export Bookings
                    </button>

                    <button
                      className="btn secondary-button-no-margin-hover btn-c export-bookings-button"
                      onClick={openExportToXeroModal}
                    >
                      Export To Xero
                    </button>

                    {showExportBookingPopup && (
                      <Modal
                        show={true}
                        header="Export Bookings"
                        className="export-booking-modal"
                        onClose={() => setShowExportBookingPopup(false)}
                      >
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-10">
                            <FormDatePicker
                              label="Start Date"
                              onChange={(date) => setExportBookingStartDate(moment(date).format("YYYY-MM-DD"))}
                              value={moment(exportBookingStartDate).format("DD-MM-YYYY")}
                              // maxDate={new Date()}
                              dateFormat="YYYY-MM-DD"
                              maxWidth
                              required
                            />
                          </div>
                          <div className="col-md-10">
                            <FormDatePicker
                              label="End Date"
                              onChange={(date) => setExportBookingEndDate(moment(date).format("YYYY-MM-DD"))}
                              value={moment(exportBookingEndDate).format("DD-MM-YYYY")}
                              dateFormat="YYYY-MM-DD"
                              minDate={exportBookingStartDate}
                              // maxDate={new Date()}
                              maxWidth
                              required
                            />
                          </div>
                          <div className="col-md-10">
                            <FormField
                              label="Teachers"
                              disabled
                              value={allUsers
                                .filter(user => exportBookingTeachers.includes(user._id))
                                .map(user => {return getTeacherProfileName(user)})
                                .join(', ')}
                            >
                            </FormField>
                          </div>
                          <div className="mt-5 col-md-8 d-flex justify-content-center">
                            <button
                              className="btn btn-primary"
                              onClick={handleExportBooking}
                            >
                              Export
                            </button>
                          </div>
                        </div>
                      </Modal>
                    )}

                    {showExportToXeroPopup && (
                      <Modal
                        show={true}
                        header="Export to Xero"
                        className="export-booking-modal"
                        onClose={() => setShowExportToXeroPopup(false)}
                      >
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-10">
                            <FormDatePicker
                              label="Start Date"
                              onChange={(date) => setExportToXeroStartDate(moment(date).format("YYYY-MM-DD"))}
                              value={moment(exportToXeroStartDate).format("DD-MM-YYYY")}
                              // maxDate={new Date()}
                              dateFormat="YYYY-MM-DD"
                              maxWidth
                              required
                            />
                          </div>
                          <div className="col-md-10">
                            <FormDatePicker
                              label="End Date"
                              onChange={(date) => setExportToXeroEndDate(moment(date).format("YYYY-MM-DD"))}
                              value={moment(exportToXeroEndDate).format("DD-MM-YYYY")}
                              dateFormat="YYYY-MM-DD"
                              minDate={exportToXeroStartDate}
                              // maxDate={new Date()}
                              maxWidth
                              required
                            />
                          </div>
                          <div className="col-md-10">
                            <FormField
                              label="Teachers"
                              disabled
                              value={allUsers
                                .filter(user => exportBookingTeachers.includes(user._id))
                                .map(user => {return getTeacherProfileName(user)})
                                .join(', ')}
                            >
                            </FormField>
                          </div>
                          <div className="mt-5 col-md-8 d-flex justify-content-center">
                            <button
                              className="btn btn-primary"
                              onClick={handleExportToXero}
                            >
                              Export
                            </button>
                          </div>
                        </div>
                      </Modal>
                    )}

                    {showConfirmChangeStatusPopup && (
                      <Modal
                        show={true}
                        header="Update Searchable Status"
                        className="export-booking-modal"
                        onClose={() => {
                          setShowConfirmChangeStatusPopup(false);
                          setStatusChangedTeacher(undefined);
                        }}
                      >
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-10 text-center">
                            Are you sure you want to update the status of {" "}
                            {getTeacherProfileName(statusChangedTeacher) + " "}
                            to {" "}
                            <p className={statusChangedTeacher.is_searchable ? "d-inline" : "d-none"}>not</p>{" "}
                            searchable?
                          </div>
                          <div className="mt-5 col-md-8 d-flex justify-content-center">
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                props.updateSearchStatus(statusChangedTeacher._id, !statusChangedTeacher.is_searchable);
                                setShowConfirmChangeStatusPopup(false);
                                setStatusChangedTeacher(undefined);
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </Modal>
                    )}

                    {showConfirmChangeLevelPopup && (
                      <Modal
                        show={true}
                        header="Update Teacher Level"
                        className="export-booking-modal"
                        onClose={() => {
                          setShowConfirmChangeLevelPopup(false);
                          setLevelChangedTeacher(undefined);
                        }}
                      >
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-10 text-center">
                            Are you sure you want to update the level of {" "}
                            {getTeacherProfileName(levelChangedTeacher) + " "}
                            to {" "}
                            <p className="d-inline">
                              {levelChangedTeacher.level === "senior" ? "junior" : "senior"}
                            </p>
                            ?
                          </div>
                          <div className="mt-5 col-md-8 d-flex justify-content-center">
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                props.updateTeacherLevel(
                                  levelChangedTeacher._id,
                                  levelChangedTeacher.level === "senior" ? "junior" : "senior"
                                )
                                setShowConfirmChangeLevelPopup(false);
                                setLevelChangedTeacher(undefined);
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </Modal>
                    )}

                    <div className="availability-table">
                      <div className="availability-table-header">
                        <div className="availability-table-header-card availability-header-behind"></div>
                        <span
                          id="front-header"
                          className="availability-table-header-card"
                        >
                          <div className="similar-to-h4-style av-table-header-first-line">
                            All Teachers
                          </div>
                          <div className=" av-table-header-second-line similar-to-h4-style-1">
                            Details of all teachers
                          </div>
                        </span>
                      </div>
                      <div className="availability-table-body mb-0">
                        <div className="availability-table-body-content overflow-auto">
                          <table className="av-tab-root">
                            <thead className="availability-table-head">
                              <tr className="availability-table-head-row">
                                <th className="availability-table-head-cell">
                                  Teacher Name
                                </th>
                                <th className="availability-table-head-cell">
                                  Email
                                </th>
                                <th className="availability-table-head-cell">
                                  Contact Number
                                </th>
                                <th className="availability-table-head-cell">
                                  State
                                </th>
                                <th className="availability-table-head-cell">
                                  Profile
                                </th>
                                <th className="availability-table-head-cell">
                                  Share
                                </th>
                                <th className="availability-table-head-cell">
                                  Hyperlink
                                </th>
                                <th className="availability-table-head-cell">
                                  Details
                                </th>
                                <th className="availability-table-head-cell">
                                  Searchable?
                                </th>
                                <th className="availability-table-head-cell">
                                  Senior?
                                </th>
                                <th className="availability-table-head-cell">
                                  Export Bookings
                                </th>
                              </tr>
                            </thead>
                            <tbody className="availability-table-body-bodytable">
                              {showCurrentUsers.map((user, index) => (
                                <tr
                                  key={index}
                                  className="availability-table-body-row"
                                >
                                  <td
                                    value={user._id}
                                    id={user._id}
                                    className="availability-table-cell"
                                  >
                                    {user.first_name} {user.preferred_name && user.preferred_name !== user.first_name ? ' \'' + user.preferred_name.trim() + '\'' : null} {user.last_name}
                                  </td>
                                  <td className="availability-table-cell small">
                                    <Link
                                      id={"email" + user.email}
                                      className="mdi mdi-link-variant home-icon-margin-adjust profile-link"
                                      to={{}}
                                      onClick={() => {
                                        navigator.clipboard.writeText(user.email)
                                        notify.show("Email copied to clipboard");
                                      }}
                                    >
                                      {" "}
                                    </Link>

                                  </td>
                                  <td className="availability-table-cell">
                                    {user.contact_number}
                                  </td>
                                  <td className="availability-table-cell">
                                    {user.state || "N.A."}
                                  </td>
                                  <td className="availability-table-cell">
                                    {/* <Link className="btn btn-success" onClick= {() => handledetails(user._id)}>More Details</Link> */}
                                    {/* <Link className="mdi mdi-account-circle-outline home-icon-margin-adjust profile-link" to={{ pathname: `https://master.d2ui2xxezlfztd.amplifyapp.com/NavigateToShareProfile?id=${user.email}`}}  target="blank"></Link> */}
                                    <Link
                                      className="mdi mdi-account-circle-outline home-icon-margin-adjust profile-link"
                                      to={{
                                        pathname: `/NavigateToShareProfile?id=${user._id}`,
                                      }}
                                      target="blank"
                                    ></Link>
                                  </td>
                                  <td className="availability-table-cell">
                                    <Link
                                      className="mdi mdi-share home-icon-margin-adjust profile-link"
                                      id="lnkShareProfile"
                                      target="_self"
                                      onClick={() => showShareProfile(user)}
                                    ></Link>
                                  </td>

                                  <td className="availability-table-cell">
                                    <span
                                      id={"lnkProfile" + user._id}
                                      className="d-none"
                                    >
                                      {POFILE_URL + user._id}
                                    </span>
                                    <span
                                      className="d-inline-block"
                                      id="tooltip"
                                      tabIndex="0"
                                      data-toggle="tooltip"
                                      title="Copy Profile Link"
                                    >
                                      <Link
                                        id={"t" + user._id}
                                        className="mdi mdi-link-variant home-icon-margin-adjust profile-link"
                                        to={{}}
                                        onClick={() => {
                                          copyToClipboard(
                                            "lnkProfile" + user._id
                                          )
                                        }}
                                      >
                                        {" "}
                                      </Link>
                                        
                                      <Link
                                        className="mdi  mdi-timetable home-icon-margin-adjust profile-link"
                                        title="Nav Teach Calendar"
                                        onClick={() => ( 
                                          window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(user)),
                                          props.history.push("/TeacherCalendar")
                                      )}
                                      >
                                      </Link>
                                    </span>
                                    {/* <input type="text" placeholder="Paste here for test" /> */}
                                  </td>

                                  <td className="availability-table-cell">
                                    <Link
                                      className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                                      onClick={() => (
                                        props.setTeacher(user),
                                        // window.localStorage.setItem(
                                        //   "teacher",
                                        //   JSON.stringify(user)
                                        // ),
                                        props.history.push(
                                          "/TeacherpersonalDetails"
                                        )
                                      )}
                                    >
                                      More
                                    </Link>
                                  </td>
                                  <td className="availability-table-cell">
                                    <CheckableButton
                                      className="mx-auto"
                                      checkbox
                                      noBorder
                                      checked={user.is_searchable}
                                      onChange={() => {
                                        setShowConfirmChangeStatusPopup(true);
                                        setStatusChangedTeacher(user);
                                      }}
                                    />
                                  </td>
                                  <td className="availability-table-cell">
                                    <CheckableButton
                                      className="mx-auto"
                                      checkbox
                                      noBorder
                                      checked={user.level === "senior"}
                                      onChange={(e) => {
                                        // const level = e.target.checked ? "senior" : "junior";
                                        // props.updateTeacherLevel(user._id, level)
                                        setShowConfirmChangeLevelPopup(true);
                                        setLevelChangedTeacher(user);
                                      }}
                                    />
                                  </td>
                                  <td className="availability-table-cell">
                                    <CheckableButton
                                      className="mx-auto"
                                      checkbox
                                      noBorder
                                      id={user._id}
                                      checked={exportBookingTeachers.includes(user._id)}
                                      onChange={updateExportBookingTeachers}
                                    />
                                  </td>
                                  {
                                    //onClick = {handledetails(user._id)}
                                  }
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div className="row bookings-bottom pb-0">
                          <div className="col-lg-3 col-md-0 "></div>
                          <div className="col-lg-6  col-md-12 bookings-bottom-pagination">
                            {searchResults.length ? (
                              <Pagination
                                itemArray={searchResults}
                                pageNum={pageNum}
                                onPageNumChange={onPageNumChange}
                              />
                            ) : null}
                          </div>
                          <div className="col-lg-3 col-md-12"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminWrapper>
  )
}

function mapStateToProps(state) {
  return {
    all_users: state.admin.all_users,
  }
}

const mapDispatchToProps = {
  setTeacher,
  setAllTeachers,
  updateSearchStatus,
  updateTeacherLevel
}

export default connect(mapStateToProps, mapDispatchToProps)(AllTeachers)
